import { render, staticRenderFns } from "./ExtraDataSection.vue?vue&type=template&id=5a467188&scoped=true&"
import script from "./ExtraDataSection.vue?vue&type=script&lang=js&"
export * from "./ExtraDataSection.vue?vue&type=script&lang=js&"
import style0 from "./ExtraDataSection.vue?vue&type=style&index=0&id=5a467188&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a467188",
  null
  
)

export default component.exports